/* Keep the existing email typography while avoiding iOS automatic focus zoom.
 * Scope the viewport adjustment to this field; restore it when editing ends.
 */
(() => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isIOS) return;
  const viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) return;
  let original;
  const prepare = event => {
    if (!event.target.matches?.('.notify-me-form__input')) return;
    if (original !== undefined) return;
    // Do not reset a deliberate user zoom level.
    if (window.visualViewport && window.visualViewport.scale > 1.05) return;
    original = viewport.getAttribute('content') || '';
    const content = original.split(',').filter(part => !/^\s*maximum-scale\s*=/i.test(part));
    viewport.setAttribute('content', [...content, 'maximum-scale=1'].join(','));
  };
  const restore = () => {
    if (original === undefined) return;
    viewport.setAttribute('content', original);
    original = undefined;
  };
  document.addEventListener('pointerdown', prepare, true);
  document.addEventListener('touchstart', prepare, { capture: true, passive: true });
  document.addEventListener('focusin', prepare, true);
  document.addEventListener('focusout', event => {
    if (event.target.matches?.('.notify-me-form__input')
      && !event.relatedTarget?.matches?.('.notify-me-form__input')) restore();
  }, true);
  window.addEventListener('pagehide', restore);
})();
